import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  alertRuleEditDialogContent: {
    paddingTop: `${theme.spacing(2)} !important`,
    paddingBottom: `${theme.spacing(2)} !important`
  },
  mdxEditor: {
    '.cm-richView': {
      minHeight: '5rem'
    }
  },
  error: {
    borderColor: theme.vars.palette.error.main
  }
}));

export default useStyles;
